<template>
    <div data-aos="fade-up"
        data-aos-offset="300"
        data-aos-delay="200"
        data-aos-duration="600"
        class="partner-slide">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/1.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/2.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/3.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/4.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/5.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/6.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/7.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/8.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/9.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/10.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/1.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/2.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/3.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/4.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/5.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/6.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/7.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/8.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/9.png" alt=""></div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <router-link class="partner-slide__box" to="/gshop/brand">
                        <div class="partner-slide__thumb"><img src="/images/main/partners/10.png" alt=""></div>
                    </router-link>
                </div>
            </div>
            <div class="buttons">
                <button class="prev" type="button"></button>
                <button class="next" type="button"></button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    mounted(){
        this.$nextTick(() => {
            var partnerSlide = new window.Swiper ('.partner-slide .swiper-container', {
                slidesPerView: 'auto',
                spaceBetween : 18,
                speed: 500,
                loop: true,
                autoplay: {
                    delay: 1000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: '.partner-slide .next',
                    prevEl: '.partner-slide .prev'
                }
            });
        });
    }
}
</script>


<style scoped>
.partner-slide { position: relative; }
.partner-slide .swiper-container { overflow: visible; }
.partner-slide .swiper-slide { width: auto; }
.partner-slide .buttons{ display:none; }
.partner-slide .buttons button { margin-left: -1px; width: 45px; height: 45px; border: 1px solid #dddddd; background-repeat: no-repeat; background-position: center; }
.partner-slide .buttons button:hover { background-color: #aeaeae; }
.partner-slide .buttons .prev { background-image: url('/images/icon/prev.png'); }
.partner-slide .buttons .prev:hover { background-image: url('/images/icon/prev-light.png'); }
.partner-slide .buttons .next { background-image: url('/images/icon/next.png'); }
.partner-slide .buttons .next:hover { background-image: url('/images/icon/next-light.png'); }
.partner-slide__box { overflow: hidden; display: block; position: relative; background: #ffffff; border-radius: 50%; box-shadow: 0px 7px 20px 0px rgba(0,0,0,.1); }
.partner-slide__thumb { width: 120px; height: 120px; }
.partner-slide__thumb::after { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: #1a284d; opacity: 0; -webkit-transition: all ease .15s; transition: all ease .15s; }
.partner-slide__thumb img { position: absolute; top: 0; left: 0; width: 100%; height: auto; }
.partner-slide__box:hover .partner-slide__thumb::after { opacity: .5; }
@media (min-width:576px){
}
@media (min-width:768px){
    .partner-slide .buttons{
        display: flex;
        position: absolute; top: -108px; right: calc(50vw - 600px);
    }
    /* .partner-slide__thumb { width: 180px; height: 180px; } */
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}
</style>